import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "components/basic/typography";
import Radio from "components/basic/radio";

interface PickableService {
  id: number;
  quoteValidFor: string;
  evChargerServiceFields?: { id: number }[] | null;
}

interface ServicePickerProps {
  services: PickableService[];
  selectedId: number | null;
  disabled?: boolean;
  onSelect: (serviceId: number) => void;
}

/**
 * Which offering the private link quotes from. Only shown when the vendor has
 * more than one: with a single live service the server already uses it, and a
 * one-option picker is just a decision the vendor does not need to make.
 */
const ServicePicker: React.FC<ServicePickerProps> = ({
  services,
  selectedId,
  disabled,
  onSelect,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("profile");

  if (services.length < 2) {
    return null;
  }

  return (
    <div style={{ marginTop: theme.spacing(4) }}>
      <Typography variant="body1">{t("private_link.quote_from")}</Typography>
      <Typography
        variant="body2"
        style={{
          color: theme.palette.grey[700],
          marginTop: theme.spacing(0.5),
        }}
      >
        {t("private_link.pick_service")}
      </Typography>

      <div style={{ marginTop: theme.spacing(1) }}>
        {services.map((service) => (
          <Radio
            key={service.id}
            isSelected={service.id === selectedId}
            disabled={disabled}
            onChange={() => onSelect(service.id)}
            label={t("private_link.service_option", {
              id: service.id,
              validFor: service.quoteValidFor,
              count: service.evChargerServiceFields?.length ?? 0,
            })}
          />
        ))}
      </div>
    </div>
  );
};

export default ServicePicker;
